import tinycolor from "tinycolor2";

export const WHITE = tinycolor("white");
export const BLACK = tinycolor("black");

export const createTinyColor = (color?: string | tinycolor.Instance) => {
  const tinyColorInstance = tinycolor(color ?? "invalid");

  let contrastColor: ReturnType<typeof createTinyColor> | undefined;

  return {
    get isValid() {
      return tinyColorInstance.isValid();
    },
    get contrastColor() {
      const color = tinycolor.mostReadable(tinyColorInstance, [WHITE, BLACK]);

      contrastColor = contrastColor ?? createTinyColor(color);
      return contrastColor;
    },
    get value() {
      return tinyColorInstance.toString();
    },
    getTransparentTinyColor(amount = 0.8) {
      if (!this.isValid) {
        // Cloning an invalid color instance will make it a valid black color so let's return the original color instance to retain the invalid state
        return this;
      }

      const newColor = tinyColorInstance.clone().setAlpha(amount);

      return createTinyColor(newColor);
    },

    getBrightnessAdjustedTinyColor(amount = 10) {
      if (!this.isValid) {
        // Cloning an invalid color instance will make it a valid black color so let's return the original color instance to retain the invalid state
        return this;
      }

      const isDark = tinyColorInstance.isDark();
      const newColor = tinyColorInstance.clone();

      if (isDark) {
        newColor.lighten(amount);
      } else {
        newColor.darken(amount);
      }

      return createTinyColor(newColor);
    },
  };
};
